export const types = {
  INVITE_MISSING_MEMBERS_REQUEST:
    'ORGANIZATIONS/INVITE_MISSING_MEMBERS_REQUEST',
  INVITE_MISSING_MEMBERS_SUCCESS:
    'ORGANIZATIONS/INVITE_MISSING_MEMBERS_SUCCESS',
  INVITE_MISSING_MEMBERS_FAILURE:
    'ORGANIZATIONS/INVITE_MISSING_MEMBERS_FAILURE',
  MEMBERS_REQUEST: 'ORGANIZATIONS/MEMBERS_REQUEST',
  MEMBERS_SUCCESS: 'ORGANIZATIONS/MEMBERS_SUCCESS',
  MEMBERS_FAILURE: 'ORGANIZATIONS/MEMBERS_FAILURE',
  FETCH_MEMBERSHIP_DATA_REQUEST: 'ORGANIZATIONS/FETCH_MEMBERSHIP_DATA_REQUEST',
  FETCH_MEMBERSHIP_DATA_SUCCESS: 'ORGANIZATIONS/FETCH_MEMBERSHIP_DATA_SUCCESS',
  FETCH_MEMBERSHIP_DATA_FAILURE: 'ORGANIZATIONS/FETCH_MEMBERSHIP_DATA_FAILURE',
  MISSING_MEMBERS_REQUEST: 'ORGANIZATIONS/MISSING_MEMBERS_REQUEST',
  MISSING_MEMBERS_SUCCESS: 'ORGANIZATIONS/MISSING_MEMBERS_SUCCESS',
  MISSING_MEMBERS_FAILURE: 'ORGANIZATIONS/MISSING_MEMBERS_FAILURE',
  OWNERSHIP_REQUEST: 'ORGANIZATIONS/OWNERSHIP_REQUEST',
  OWNERSHIP_SUCCESS: 'ORGANIZATIONS/OWNERSHIP_SUCCESS',
  OWNERSHIP_FAILURE: 'ORGANIZATIONS/OWNERSHIP_FAILURE',
};

export const initialOrganizationState = {
  error: null,
  isLoadingMembers: false,
  isLoadingMissingMembers: false,
  members: null,
  missingMembers: null,
};

const organizationState = (state = initialOrganizationState, action) => {
  switch (action.type) {
    case types.INVITE_MISSING_MEMBERS_REQUEST:
      return { ...state, isLoadingMissingMembers: true, error: null };
    case types.INVITE_MISSING_MEMBERS_SUCCESS:
      return { ...state, isLoadingMissingMembers: false };
    case types.INVITE_MISSING_MEMBERS_FAILURE:
      return { ...state, isLoadingMissingMembers: false, error: action.error };
    case types.MEMBERS_REQUEST:
      return { ...state, isLoadingMemebers: true, error: null };
    case types.MEMBERS_SUCCESS:
      return { ...state, isLoadingMembers: false, members: action.members };
    case types.MEMBERS_FAILURE:
      return { ...state, isLoadingMembers: false, error: action.error };
    case types.MISSING_MEMBERS_REQUEST:
      return { ...state, isLoadingMissingMembers: true, error: null };
    case types.MISSING_MEMBERS_SUCCESS:
      return {
        ...state,
        isLoadingMissingMembers: false,
        missingMembers: action.missingMembers,
      };
    case types.MISSING_MEMBERS_FAILURE:
      return { ...state, isLoadingMissingMembers: false, error: action.error };
    case types.OWNERSHIP_REQUEST:
      return { ...state, isLoadingMemebers: true, error: null };
    case types.OWNERSHIP_SUCCESS:
      return { ...state, isLoadingMemebers: false, members: action.members };
    case types.OWNERSHIP_FAILURE:
      return { ...state, isLoadingMemebers: false, error: action.error };
    default:
      return state;
  }
};

export default (state = {}, action) => {
  if (Object.values(types).indexOf(action.type) > -1) {
    const organizationUuid = action.organizationUuid;
    return {
      ...state,
      [organizationUuid]: organizationState(state[organizationUuid], action),
    };
  }
  return state;
};

export const actions = {
  fetchMembers: (organizationUuid) => ({
    type: types.MEMBERS_REQUEST,
    organizationUuid,
  }),
  fetchMissingMembers: (organizationUuid) => ({
    type: types.MISSING_MEMBERS_REQUEST,
    organizationUuid,
  }),
  toggleOwnership: (organizationUuid, userUuid, role) => {
    return { type: types.OWNERSHIP_REQUEST, organizationUuid, userUuid, role };
  },
  inviteMissingMembers: (invites, organizationUuid) => ({
    type: types.INVITE_MISSING_MEMBERS_REQUEST,
    invites,
    organizationUuid,
  }),
  fetchMembershipData: (organizationUuid) => ({
    type: types.FETCH_MEMBERSHIP_DATA_REQUEST,
    organizationUuid,
  }),
};

export const selectors = {
  membersForOrganization: (state, organizationUuid) => {
    const orgData = state.organizationMembers[organizationUuid];
    return orgData?.members ?? null;
  },
  missingMembersForOrganization: (state, organizationUuid) => {
    const orgData = state.organizationMembers[organizationUuid];
    return orgData?.missingMembers ?? null;
  },
  isLoadingMembersForOrganization: (state, organizationUuid) => {
    const orgData = state.organizationMembers[organizationUuid];
    return orgData?.isLoadingMembers ?? false;
  },
  isLoadingMissingMembersForOrganization: (state, organizationUuid) => {
    const orgData = state.organizationMembers[organizationUuid];
    return orgData?.isLoadingMissingMembers ?? false;
  },
};
